import MuiAppBar, { type AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'
import MuiBottomNavigation, {
  type BottomNavigationProps as MuiBottomNavigationProps,
} from '@mui/material/BottomNavigation'
import MuiBottomNavigationAction, {
  type BottomNavigationActionProps as MuiBottomNavigationActionProps,
} from '@mui/material/BottomNavigationAction'
import MuiToolbar, { type ToolbarProps as MuiToolbarProps } from '@mui/material/Toolbar'
import MuiLink, { type LinkProps as MuiLinkProps } from '@mui/material/Link'
import MuiMenu, { type MenuProps as MuiMenuProps } from '@mui/material/Menu'
import MuiMenuList, { type MenuListProps as MuiMenuListProps } from '@mui/material/MenuList'
import MuiBreadcrumbs, { type BreadcrumbsProps as MuiBreadcrumbsProps } from '@mui/material/Breadcrumbs'

//* APP BAR
export const AppBar = MuiAppBar
export type AppBarProps = MuiAppBarProps

//* BOTTOM NAVIGATION
export const BottomNavigation = MuiBottomNavigation
export type BottomNavigationProps = MuiBottomNavigationProps

//* BOTTOM NAVIGATION ACTION
export const BottomNavigationAction = MuiBottomNavigationAction
export type BottomNavigationActionProps = MuiBottomNavigationActionProps

//* TOOLBAR
export const Toolbar = MuiToolbar
export type ToolbarProps = MuiToolbarProps

//* LINK
export const Link = MuiLink
export type LinkProps = MuiLinkProps

//* MENU
export const Menu = MuiMenu
export type MenuProps = MuiMenuProps

//* MENU LIST
export const MenuList = MuiMenuList
export type MenuListProps = MuiMenuListProps

//* BREADCRUMBS
export const Breadcrumbs = MuiBreadcrumbs
export type BreadcrumbsProps = MuiBreadcrumbsProps
